// extracted by mini-css-extract-plugin
export default {"wrapper":"pzb6tt","wrapper--l":"aNhvc_","wrapper--m":"egLew1","wrapper--s":"nTHQfh","wrapper--xl":"wAxcpr"};